const fetch = require('cross-fetch');
const mappingUrl = 'https://tracking.cdn.vpsvc.com/sources/metadata.json';
async function getMapping() {
  const response = await fetch(mappingUrl);
  if (!response.ok) {
    throw new Error('Unable to fetch write keys mapping.');
  }
  return await response.json();
}
module.exports = getMapping;